// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"99b60dc8","381":"47cc136f","484":"65db1cc1","567":"75e757a9","919":"0f9c4767","990":"4a5429ab"}[chunkId] + ".chunk.js";
};